module.exports = __webpack_public_path__ + "static/media/9.37384c02.png";